import { styled, Typography } from "@mui/material"

export const ErrorStyle = styled(Typography)(({ theme }) => ({
  color: theme.palette.mockup.error50,
  position: "absolute",
  fontWeight: "500",
  bottom: 0,
}))
